import * as React from 'react'
import { graphql } from 'gatsby'
import Map from '../homepage/Map'

export const MapSection = () => {
  return <Map />
}

MapSection.propTypes = {}

export const query = graphql`
  fragment MapSection on STRAPI__COMPONENT_SECTION_CONTACT_US_MAP {
    id
    strapi_component
  }
`

export default MapSection
